/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import posthog from 'posthog'
import { POSTHOG_ENABLED } from 'helpers/config'
import { Driver } from 'types/entities/Driver'

const isPosthogReady = (): boolean =>
    POSTHOG_ENABLED && !(window as Window & { Cypress?: unknown }).Cypress

export const identifyPosthogUser = (user: Pick<Driver, 'id' | 'email' | 'name' | 'last_name' | 'username'>): void => {
    if (!isPosthogReady() || !user?.id) {
        return
    }

    posthog.identify(String(user.id), {
        email: user.email || undefined,
        name: [user.name, user.last_name].filter(Boolean).join(' ') || undefined,
        username: user.username || undefined,
    })
}

export const resetPosthogUser = (): void => {
    if (!isPosthogReady()) {
        return
    }

    posthog.reset()
}

export const capturePosthogEvent = (
    eventName: string,
    properties?: Record<string, unknown>
): void => {
    if (!isPosthogReady()) {
        return
    }

    posthog.capture(eventName, properties)
}
